import { render, staticRenderFns } from "./DoctypeManagement.vue?vue&type=template&id=2e514726&"
import script from "./DoctypeManagement.vue?vue&type=script&lang=js&"
export * from "./DoctypeManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports